"use strict";

// ServerStatusService is where we keep track of server state.  At the moment, this includes which payment forms are currently process-able
angular.module('PatientApp').factory('ServerStatusService', function (VuexStore) {
  return {
    updatePaymentStatus: function updatePaymentStatus(availableMethods) {
      VuexStore.dispatch('updatePaymentStatus', availableMethods);
    },
    getPaymentStatus: function getPaymentStatus(paymentType) {
      return VuexStore.getters.getPaymentStatus(paymentType);
    },
    updateXsrfToken: function updateXsrfToken(xsrfToken) {
      VuexStore.dispatch('updateXsrfToken', xsrfToken);
    },
    getXsrfToken: function getXsrfToken() {
      return localStorage.getItem('XSRF-TOKEN');
    }
  };
});